import { createStore } from 'vuex';

function decodeToken(token) {
    if (!token) return null;
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        console.error('Invalid token', e);
        return null;
    }
}

export default createStore({
    state: {
        token: null,
        user: null,
        roles: [],
        lang: localStorage.getItem('locale') || 'en',
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
            const decodedToken = decodeToken(token);
            state.user = decodedToken;
            state.roles = decodedToken?.roles || [];
        },
        clearToken(state) {
            state.token = null;
            state.user = null;
            state.roles = [];
        },
        setLang(state, lang) {
            state.lang = lang;
            localStorage.setItem('locale', lang);
        },
        SET_ROLES(state, roles) {
            state.roles = roles;
        }
    },
    actions: {
        login({ commit }, token) {
            commit('setToken', token);
            localStorage.setItem('authToken', token);
        },
        logout({ commit }) {
            commit('clearToken');
            localStorage.removeItem('authToken');
        },
        updateLang({ commit }, lang) {
            commit('setLang', lang);
        },
        decodeToken({ commit }) {
            const token = localStorage.getItem('authToken');
            if (token) {
                try {
                    const decoded = decodeToken(token);
                    let roles = decoded?.roles || [];

                    if (roles.includes('ROLE_ADMIN') && !decoded.ipAllowed) {
                        roles = roles.filter(role => role !== "ROLE_ADMIN");
                    }
                    commit("SET_ROLES", roles);
                } catch (error) {
                    console.error("Invalid token:", error);
                }
            }
        }
    },
    getters: {
        isAuthenticated: (state) => !!state.token,
        userRoles: (state) => state.roles,
        currentLang: (state) => state.lang,
        isTestator: (state) => state.roles.includes("ROLE_TESTATOR"),
        isAdmin: (state) => state.roles.includes("ROLE_ADMIN"),
    },
});
